export default {
  promo_categories: []
}
